// @greenlight-spec: 27-fleet-health-monitor.md#the-responses-release_validation-object
// @greenlight-spec: 26-versioning-update-strategy.md#release-validation
// @greenlight-spec: decisions/0068-release-validation-on-shift-installs.md
import { z } from 'zod';
/**
 * The one thing Shift decides about an install's testing role, on the `202`
 * body of `POST /api/v1/reports`: the operator-set `gates_releases` flag,
 * exactly as stored. An install that reads `true` here and takes prereleases
 * is a release-validation install.
 */
export const FleetReleaseValidationSchema = z.object({
    gates_releases: z.boolean(),
});
/**
 * How the install reads that object. Anything but a well-formed object reads
 * as absent, and absent reads as `false`: the role fails closed, and a
 * malformed answer must not cost the install the entitlement carried on the
 * same body.
 */
export const FleetReleaseValidationResponseSchema = FleetReleaseValidationSchema.optional().catch(undefined);
/**
 * The install's own statement of the role, in the fleet report: the persisted
 * `gates_releases` answer **and** `include_prereleases`. The monitor never
 * trusts it to enrol an install — it exists so the monitor can alert when an
 * install outside Shift ever claims the role.
 */
export const FleetReleaseValidationPostureSchema = z.object({
    enabled: z.boolean(),
});
/**
 * API projection of the switch for `/internal-health`: what Shift last
 * answered, the install's own half, and the two together. `received_at` is
 * `null` until Shift has answered at all.
 */
export const FleetReleaseValidationSwitchSchema = z.object({
    gates_releases: z.boolean(),
    include_prereleases: z.boolean(),
    enabled: z.boolean(),
    received_at: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=fleet-release-validation.js.map